import { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { api, type Me } from "./lib/api-client";
import MailLayout from "./features/mailbox/MailLayout";
import LoginPage from "./features/auth/LoginPage";
import { useTheme } from "./lib/theme";

type AuthState = { status: "loading" } | { status: "ready"; me: Me } | { status: "error" };

export default function App() {
  const [auth, setAuth] = useState<AuthState>({ status: "loading" });
  const [theme, setTheme] = useTheme();

  useEffect(() => {
    api
      .me()
      .then((me) => setAuth({ status: "ready", me }))
      .catch(() => setAuth({ status: "error" }));
  }, []);

  if (auth.status === "loading") {
    return <CenteredMessage text="Cargando…" />;
  }

  if (auth.status === "error") {
    return <LoginPage />;
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/mailbox" replace />} />
      <Route
        path="/mailbox"
        element={<MailLayout me={auth.me} theme={theme} onThemeChange={setTheme} />}
      />
      <Route
        path="/mailbox/:mailboxId"
        element={<MailLayout me={auth.me} theme={theme} onThemeChange={setTheme} />}
      />
      <Route
        path="/mailbox/:mailboxId/message/:messageId"
        element={<MailLayout me={auth.me} theme={theme} onThemeChange={setTheme} />}
      />
    </Routes>
  );
}

function CenteredMessage({ text }: { text: string }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        fontFamily: "var(--font-body)",
        color: "var(--text-secondary)",
      }}
    >
      {text}
    </div>
  );
}
